import { SectionCaption } from '@app/core/components/SectionCaption';
import { Alert, Box } from '@mui/material';
import { MessageDescriptor, FormattedMessage } from 'react-intl';
import { VerifyMatchTranscriptionSkeleton } from './VerifyMatchTranscriptionSkeleton';
import { VerifyMatchTranscriptionText } from './VerifyMatchTranscriptionText';

export interface VerifyMatchTextSectionProps {
  /** Section caption above the body. */
  title: MessageDescriptor;
  /** Message shown when loading/error/empty leave no content. */
  emptyMessage: MessageDescriptor;
  content: string | null | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Shared caption + loading / error / empty / text body for verify-dialog text panels.
 */
export function VerifyMatchTextSection({
  title,
  emptyMessage,
  content,
  isLoading,
  isError,
}: VerifyMatchTextSectionProps) {
  return (
    <Box>
      <SectionCaption message={title} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {isLoading && !content && <VerifyMatchTranscriptionSkeleton />}
        {isError && !content && (
          <Alert severity="warning">
            <FormattedMessage {...emptyMessage} />
          </Alert>
        )}
        {!isLoading && !content && !isError && (
          <Alert severity="info">
            <FormattedMessage {...emptyMessage} />
          </Alert>
        )}
        {content && <VerifyMatchTranscriptionText>{content}</VerifyMatchTranscriptionText>}
      </Box>
    </Box>
  );
}
